import React from "react";
import { AnimatedBlock, interpolate, useMountedValue } from "react-ui-animate";
import { MdClose } from "react-icons/all";
import { FILE_URL } from "../../../config/Api.config";

const ImageViewer = ({ open, close, activeImage, isVideo = false }) => {
  const mountedValue = useMountedValue(open, [0, 1, 0]);

  return (
    <>
      {mountedValue(
        (animation, mounted) =>
          mounted && (
            <AnimatedBlock
              className="imageviewer-container"
              style={{
                opacity: animation.value,
              }}>
              <AnimatedBlock
                className="imageviewer"
                style={{
                  transform: interpolate(
                    animation.value,
                    [0, 1],
                    ["scale(0.9)", "scale(1)"],
                  ),
                }}>
                <div className="imageviewer-close">
                  <div className="close-button" onClick={() => close(false)}>
                    <MdClose size={24} />
                  </div>
                </div>

                {!isVideo ? (
                  <img
                    key={activeImage}
                    src={FILE_URL + activeImage}
                    alt="ActiveGallery"
                  />
                ) : (
                  <div className="imageviwer-video">
                    <iframe
                      width="956"
                      height="538"
                      src={"https://www.youtube.com/embed/" + activeImage}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen></iframe>
                  </div>
                )}
              </AnimatedBlock>
            </AnimatedBlock>
          ),
      )}
    </>
  );
};

export default ImageViewer;
